var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopLeftBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 306,
    viewBox: "0 0 300 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6242 98.4895L119.294 126.953M119.294 126.953L133.558 79.7508M119.294 126.953L171.798 165.717M133.558 79.7508L188 35.2104M133.558 79.7508L15.7391 37.5572M133.558 79.7508L171.798 165.717M171.798 165.717L178.321 265.773L237.673 298.773L171.798 165.717Z",
    stroke: "#D8D8D8",
    strokeWidth: 4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.33826,
    cy: 8.7587,
    rx: 8.33826,
    ry: 8.7587,
    transform: "matrix(0.990155 0.139976 -0.211876 0.977296 126.218 69.1943)",
    fill: "#EA4335"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.7268,
    cy: 13.3686,
    rx: 12.7268,
    ry: 13.3686,
    transform: "matrix(0.990155 0.139976 -0.211876 0.977296 20.1658 85.3115)",
    fill: "#4285F4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.77711,
    cy: 9.2197,
    rx: 8.77711,
    ry: 9.2197,
    transform: "matrix(0.990155 0.139976 -0.211876 0.977296 8.81192 26.1304)",
    fill: "#F9AB00"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.11883,
    cy: 8.52821,
    rx: 8.11883,
    ry: 8.52821,
    transform: "matrix(0.990155 0.139976 -0.211876 0.977296 182.208 23.7119)",
    fill: "#34A853"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.95552,
    cy: 4.80124,
    rx: 4.95552,
    ry: 4.80124,
    transform: "matrix(0.208093 0.950031 -0.982413 0.304193 175.696 158.375)",
    fill: "#EA4335"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.56369,
    cy: 7.32822,
    rx: 7.56369,
    ry: 7.32822,
    transform: "matrix(0.208093 0.950031 -0.982413 0.304193 182.762 254.999)",
    fill: "#4285F4"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.21633,
    cy: 5.05394,
    rx: 5.21633,
    ry: 5.05394,
    transform: "matrix(0.208093 0.950031 -0.982413 0.304193 122.289 119.715)",
    fill: "#F9AB00"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.82511,
    cy: 4.6749,
    rx: 4.82511,
    ry: 4.6749,
    transform: "matrix(0.208093 0.950031 -0.982413 0.304193 240.475 292.164)",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeftBg);
export default __webpack_public_path__ + "static/media/top-left-bg.ce0698fdded80140052e801d1a1c9245.svg";
export { ForwardRef as ReactComponent };